{
  "RingtimeDistributionLabel": "Temps de sonnerie (Distribution) :",
  "RingtimeSegmentLabel": "Temps de sonnerie (segment) :",
  "CalltalktimeLabel": "Temps de conversation :",
  "TotalcalltimeLabel": "Durée totale de l'appel :",
  "CallheldtimeLabel": "Temps d'attente de l'appel :",
  "TimeComparisonAnyOptionLabel": "[N'importe lequel]",
  "TimeComparisonHigherthanOptionLabel": "Plus haut que",
  "TimeComparisonHigherequalOptionLabel": "Supérieur\/Egal",
  "TimeComparisonLowerthanOptionLabel": "Plus bas que",
  "TimeComparisonLowerequalOptionLabel": "inférieur\/égal",
  "TimeComparisonBetweenOptionLabel": "Entre",
  "TimeComparisonEqualOptionLabel": "Equal",
  "TimeComparisonNotequalOptionLabel": "Non égal",
  "TimeComparisonNotbetweenOptionLabel": "Pas entre",
  "TimeComparisonValue1Label": "Valeur :",
  "TimeComparisonValue2Label": "Et :",
  "DurationFiltering_SectionHeader": "Filtrage de la durée (historique uniquement)",
  "NAME": "DurationFiltering"
}